export const SELECT_ALL = 'Settings/GroupSettings/Assign/SELECT_ALL'
export const UNSELECT_ALL = 'Settings/GroupSettings/Assign/UNSELECT_ALL'
